// extracted by mini-css-extract-plugin
export default {"container":"HowToBeAdded_container__ljqbX","title":"HowToBeAdded_title__aQSj6"};